import { FieldError } from "../../error";
import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { exactLength, isNumber } from "../../validate";

export const ssnErrorMsg = "Must include 9 numbers only";

export class SsnField extends Field<string> {
  protected readonly _owner: BusinessOwner;

  constructor(
    model: Merchant,
    owner: BusinessOwner,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "123456789",
      propertyName: "ssn",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      ...opts,
    });

    this._owner = owner;
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry === "United States";
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    if (!exactLength(9)(this.value)) {
      throw new FieldError(this, ssnErrorMsg, "InvalidLength");
    }
    if (!isNumber(this.value)) {
      throw new FieldError(this, ssnErrorMsg, "InvalidTypeNumber");
    }
  }
}
